import { Badge } from '../components/badge/Badge';
import { Color } from '../components/common';
import { AIRCRAFT_STATUS_LABELS } from './labels';
import { AircraftStatus } from './FleetManagmentClient';

const statusColors: {[status in AircraftStatus]: Color} = {
    active: 'success',
    grounded: 'danger',
    archived: 'medium',
};

export const AircraftStatusBadge: React.FC<{status: AircraftStatus}> = ({ status }) => {
    return (
        <Badge color={statusColors[status]}>
            <span>{AIRCRAFT_STATUS_LABELS[status!]}</span>
        </Badge>
    );
};
